// src/components/BotDetailView.js

import React, { useEffect, useState } from 'react';
import { Box, Typography, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useParams } from 'react-router-dom';
import apiFetch from '../utils/api';

// Register the necessary components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const BotDetailView = () => {
  const { botName } = useParams();
  const [uptimeData, setUptimeData] = useState([]);
  const [filter, setFilter] = useState('last24Hours');

  useEffect(() => {
    fetchUptimeData();
  }, [filter]);

  const fetchUptimeData = async () => {
    try {
      const response = await apiFetch(`/api/uptime/${botName}?filter=${filter}`);
      if (response.ok) {
        const data = await response.json();
        setUptimeData(data);
      } else {
        console.error('Failed to fetch uptime data');
      }
    } catch (error) {
      console.error('Error fetching uptime data:', error);
    }
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const getChartData = () => {
    const labels = uptimeData.map((record) =>
      new Date(record.timestamp).toLocaleString()
    );
    const data = uptimeData.map((record) => (record.isOnline ? 100 : 0));

    return {
      labels,
      datasets: [
        {
          label: 'Uptime (%)',
          data,
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          tension: 0.1,
        },
      ],
    };
  };

  const getChartOptions = () => ({
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: 'Uptime (%)',
        },
      },
      x: {
        title: {
          display: true,
          text: filter === 'last24Hours' ? 'Time (Last 24 Hours)' :
                filter === 'last7Days' ? 'Date (Last 7 Days)' :
                filter === 'last30Days' ? 'Date (Last 30 Days)' :
                'Date (Last Year)',
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 20, // Adjust to ensure labels fit well
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  });

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {botName} Uptime Details
      </Typography>
      <FormControl variant="outlined" sx={{ marginBottom: 2, minWidth: 120 }}>
        <InputLabel id="filter-label">Filter</InputLabel>
        <Select
          labelId="filter-label"
          value={filter}
          onChange={handleFilterChange}
          label="Filter"
        >
          <MenuItem value="last24Hours">Last 24 Hours</MenuItem>
          <MenuItem value="last7Days">Last 7 Days</MenuItem>
          <MenuItem value="last30Days">Last 30 Days</MenuItem>
          <MenuItem value="lastYear">Last Year</MenuItem>
        </Select>
      </FormControl>
      <Box sx={{ height: 400 }}> {/* Adjust height for better visibility */}
        <Line data={getChartData()} options={getChartOptions()} />
      </Box>
    </Box>
  );
};

export default BotDetailView;
